import { styled } from "@linaria/react";
import { styleTokens } from "@ideally-ltd/design-tokens";
import { ConfirmDialog } from "primereact/confirmdialog";

const PConfirmDialog = styled(ConfirmDialog)<{ ref: React.LegacyRef<ConfirmDialog> }>`
  .p-dialog-header {
    color: ${styleTokens.Surface.Text.sub};
  }
  max-width: 25rem;
`;

export const PConfirmDialogStyle = {
  PConfirmDialog,
};
